export default __webpack_public_path__ + "static/media/facebook-icon.6dfcfb66.svg";